import { useEffect, useState } from 'react';

export function useIsDocumentReady() {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const handleLoad = () => {
      setIsReady(true);
    };

    if (['interactive', 'complete'].includes(document.readyState)) {
      setIsReady(true);
    } else {
      document.addEventListener('load', handleLoad);
    }
    return () => {
      document.removeEventListener('load', handleLoad);
    };
  }, []);

  return isReady;
}
